__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.9.1-44570d6-15806/_next/";